import { Component } from '@angular/core';

@Component({
    selector: 'app-side-info-card',
    templateUrl: './side-info-card.component.html',
    styleUrl: './side-info-card.component.scss',
    standalone: false
})
export class SideInfoCardComponent {}
